exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".score-display {\n  position: absolute;\n  top: 0;\n  right: 0;\n  pointer-events: all;\n  background-color: #482E74;\n  color: #F2F9B7;\n  padding: 0.5em;\n  border: solid 1px #222; }\n  @media (min-width: 800px) {\n    .score-display {\n      font-size: 1.5em; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/ui/ScoreDisplayComponent.scss
// module id = 139
// module chunks = 0